export interface Ambito {
	id: number;
	name: string;
	description: string;
	image: string;
}

export const ambitos: Ambito[] = [
	{
		id: 1,
		name: "Mayores",
		description:
			"Centros sociales y clubes; asociacionismo; centros de día; centros residenciales; atención domiciliaria; voluntariado.",
		image: "./assets/carrousel-mayores.jpg",
	},
	{
		id: 2,
		name: "Infancia Y Familia",
		description:
			"Servicios de prevención, diagnóstico y tratamiento para la protección de la infancia y soporte a la familia; acogimiento familiar y adopción; centros de acogida; centros residenciales; centros abiertos.",
		image: "./assets/carrousel-familia.jpg",
	},
	{
		id: 3,
		name: "LGBTI",
		description:
			"Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed euismod, nisl vel aliquam aliquam, nunc nisl aliquam nisl.",
		image: "./assets/carrousel-educacionSexual.jpg",
	},
	{
		id: 4,
		name: "Salud Mental",
		description:
			"Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed euismod, nisl vel aliquam aliquam, nunc nisl aliquam nisl.",
		image: "./assets/carrousel-saludMental.jpg",
	},
	{
		id: 5,
		name: "Medio Ambiente",
		description:
			"Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed euismod, nisl vel aliquam aliquam, nunc nisl aliquam nisl.",
		image: "./assets/carrousel-medioAmbiente.jpeg",
	},
	{
		id: 6,
		name: "Formación",
		description:
			"Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed euismod, nisl vel aliquam aliquam, nunc nisl aliquam nisl.",
		image: "./assets/carrousel-formacion.jpg",
	},
	{
		id: 7,
		name: "Diversidad Funcional",
		description:
			"Servicios de asesoramiento, valoración e información de recursos; servicios de atención precoz; servicios de diagnóstico, tratamiento y rehabilitación; formación e inserción socio-laboral; asociacionismo de personas afectadas y de familiares o grupos sensibilizados; voluntariado; pisos protegidos; defensa y tutela de los bienes de personas con incapacidad.",
		image: "./assets/carrousel-diversidad.jpg",
	},
	{
		id: 8,
		name: "Migración",
		description:
			"Servicios de acogida y atención social a migrantes y refugiados.",
		image: "./assets/carrousel-migracion-2.jpg",
	},
	{
		id: 9,
		name: "Mujer",
		description:
			"Servicios de información y atención psicosocial para la mujer; atención social de urgencia para mujeres víctimas de violencia de género y/o doméstica; casas de acogida; soporte para la formación y la inserción socio-laboral; asociacionismo y grupos de apoyo y acompañamiento.",
		image: "./assets/carrousel-mujeres.jpeg",
	},
	{
		id: 10,
		name: "Personas Sin Hogar",
		description:
			"Servicios de atención en medio abierto; centros de acogida y comedores sociales; albergues; formación e inserción socio-laboral.        ",
		image: "./assets/carrousel-sinHogar.jpeg",
	},
];
